<template>
    <!-- 投放管理 -->
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">渠道码名称:</span>

                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入渠道码名称"
                            class="handle-input mr10 promotion_qr_code"
                            @keyup.enter.native="searchPromotionQRLists"
                        ></el-input>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">渠道码编号:</span>

                        <el-input
                            v-model="search_data.promotion_qr_code"
                            placeholder="请输入渠道码编号"
                            class="handle-input mr10 promotion_qr_code"
                            @keyup.enter.native="searchPromotionQRLists"
                        ></el-input>
                    </el-col>
                </el-row>
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">投放类目:</span>
                        <el-select
                        v-model="search_data.promotion_category_code" 
                        clearable
                        placeholder="请选择类目" style="width: 330px">
                            <el-option
                                v-for="(item, index) in categoryLists"
                                :key="index"
                                :label="item.name"
                                :value="item.promotion_category_code"
                            >
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchPromotionQRLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button @click="addBtn('add')">新增渠道码</el-button>

            <!-- <el-button type="danger" @click="batchDelete">批量删除</el-button>
            <el-button type="info" @click="batchDownZipPromotionQR">批量下载</el-button> -->
            <!-- 
            <el-button
                :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'"
                @click="allDownZipPromotionQR"
                :disabled="progress_show"
                >{{ progress_show ? '批量下载中...' : '批量下载全部' }}
            </el-button> -->
        </div>
        <el-table
            :data="tableData"
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"> </el-table-column>

            <el-table-column label="渠道码名称" prop="name"> </el-table-column>

            <el-table-column label="渠道码编号" prop="promotion_qr_code"> </el-table-column>

            <el-table-column label="投放类目" prop="promotion_category_name"> </el-table-column>

            <!-- <el-table-column label="扫码次数" prop="scan_num" min-width="130"> </el-table-column> -->

            <!-- <el-table-column label="订单量" prop="order_num"> </el-table-column> -->

            <!-- <el-table-column label="订单总金额" prop="total_amount"> </el-table-column> -->

            <el-table-column label="投放时间" prop="market_time"> </el-table-column>
            <el-table-column prop="promotion_qr_code" label="渠道码">
                <template slot-scope="scope">
                    <el-image
                        style="width: 80px; height: 80px; border: 1px solid #eee; border-radius: 5px"
                        :src="scope.row.qrcode.url"
                        v-if="scope.row.qrcode.url != ''"
                        :preview-src-list="srcList"
                    >
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column width="280px" label="操作">
                <template slot-scope="scope">
                    <!-- <el-button type="primary" trigger="click" @click="bind(scope.row)"> 绑定标签 </el-button> -->

                    <el-button v-if="scope.row.loading" icon="el-icon-loading" disabled></el-button>
                    <template v-else>
                        <el-button type="primary" size="mini" @click="downZipPromotionQR(scope.row)">下载 </el-button>
                    </template>
                    <el-button type="primary" trigger="click" @click="editBtn(scope.row, 'edit')"> 编辑 </el-button>
                    <!-- <el-button type="danger" trigger="click" @click="deletePromotionQR(scope.row)"> 删除 </el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
        <!-- 添加组件 -->
        <addPromotionQR :isShow="add_isShow" :data="editData" @onSubmit="searchPromotionQRLists"></addPromotionQR>

        <!-- 绑定标签组件 -->
        <bindPromotionQRLabel :isShow="bind_isShow" :data="bindData" @onSubmit="searchPromotionQRLists"></bindPromotionQRLabel>
    </div>
</template>

<script>
var _this;
import addPromotionQR from './addPromotionQR.vue';
import addCategory from './addCategory.vue';
import bindPromotionQRLabel from './bindPromotionQRLabel.vue';

import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置

export default {
    components: {
        bindPromotionQRLabel,
        addPromotionQR,
        addCategory
    },
    data() {
        return {
            search_data_list: {
                // 投放类目查询
                page: 1,
                limit: 10
            },
            categoryLists: [],
            editData: {},
            bindData: {},
            add_isShow: false,

            bind_isShow: false,
            progress_show: false,
            promotion_qr_code: '',
            srcList: [],
            promotion_qr_code_array: [],

            // 存放表格数据
            tableData: [],
            tableDataAll: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                promotion_qr_code: '',
                promotion_category_code: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchPromotionQRLists();
        _this.promotionCategoryLists();
    },

    methods: {
        addBtn(e) {
            _this.editData.editFlag = e;
            _this.add_isShow = !_this.add_isShow;
        },

        editBtn(e, val) {
            console.log(111);
            _this.editData.editFlag = val;
            _this.editData.promotion_category_code = e.promotion_category_code;
            _this.editData.promotion_qr_code = e.promotion_qr_code;
            console.log(_this.editData.promotion_qr_code, '_this.editData.promotion_qr_code');
            _this.editData.market_time = e.market_time;
            _this.editData.promotion_category_name = e.promotion_category_name;
            _this.editData.name = e.name;
            _this.add_isShow = !_this.add_isShow;
        },
        promotionCategoryLists() {
            _this
                .$post('/promotion/promotionCategoryLists', _this.search_data_list)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        _this.categoryLists.push({ name: res.data[i].name, promotion_category_code: res.data[i].promotion_category_code });
                    }

                    // 如果一次接口请求数据少于全部数据就再次请求
                    if (_this.search_data_list.page * _this.search_data_list.limit < res.count) {
                        _this.search_data_list.page+=1;
                        _this.promotionCategoryLists();
                    }
                })
                .catch((err) => {});
        },

        allDownZipPromotionQR() {
            _this.search_data.limit = 50;
            _this.dao();
        },
        dao() {
            _this
                .$post('/promotion/promotionQRLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.tableDataAll.push(res.data);

                    if (_this.search_data.page * _this.search_data.limit < res.data.count) {
                        _this.search_data.page = _this.search_data.page + 1;
                        _this.tableDataAll.push(res.data);

                        _this.allDownZipPromotionQR();
                    } else {
                        if (_this.tableDataAll.length != 0) {
                            for (let i = 0; i < _this.tableDataAll.length; i++) {
                                for (let j = 0; j < _this.tableDataAll[i].length; j++) {
                                    _this.promotion_qr_code_array.push(_this.tableDataAll[i][j].promotion_qr_code);
                                }
                            }

                            _this.downZipBusiness('piliang');
                            _this.search_data.page = 1;
                            _this.search_data.limit = 10;
                            // 清空数据
                            _this.tableDataAll = [];
                            _this.progress_show = false;

                            _this.promotionQRLists();
                        } else {
                            _this.promotion_qr_code_array = [];
                            this.$message.error('当前列表无数据，不能下载');
                        }
                    }
                })
                .catch((err) => {});
        },
        promotionQRLists() {
            _this
                .$post('/promotion/promotionQRLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    for (let i = 0; i < res.data.length; i++) {
                        res.data[i].loading = false;
                        res.data[i].index = i;
                    }
                    _this.tableData = res.data;

                    _this.result_data = res;
                    _this.srcList.length = 0;
                    for (let i = 0; i < res.data.length; i++) {
                        _this.srcList.push(res.data[i].qrcode.hash);
                        _this.srcList.push(res.data[i].qrcode.url);
                    }
                })
                .catch((err) => {});
        },

        // 全选或多选
        handleSelectionChange(val) {
            var datalist = [];

            if (val.length != 0) {
                for (var i in val) {
                    datalist.push(val[i].promotion_qr_code);
                }
                _this.promotion_qr_code_array = datalist;
            } else {
                _this.promotion_qr_code_array = [];
            }
        },
        // 列表下载
        downZipPromotionQR(code) {
            _this.promotion_qr_code_array.push(code.promotion_qr_code);

            _this.tableData[code.index].loading = true;

            _this.downZipBusiness(code.index);
        },
        // 批量下载
        batchDownZipPromotionQR() {
            if (_this.promotion_qr_code_array.length == 0) {
                this.$message.error('请选择要下载的数据');
                return;
            }

            _this.downZipBusiness('piliang');
        },
        downZipBusiness(index) {
            axios({
                method: 'POST',
                url: config.axios_baseURL + '/promotion/downZipPromotionQR',

                data: {
                    promotion_qr_code_array: _this.promotion_qr_code_array
                },
                responseType: 'blob'
            })
                .then((response) => {
                    if (index != 'piliang') {
                        _this.tableData[index].loading = false;
                    }

                    const fileName = '渠道码下载';
                    /* 兼容ie内核，360浏览器的兼容模式 */
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        window.navigator.msSaveOrOpenBlob(blob, 'fileName');
                    } else {
                        /* 火狐谷歌的文件下载方式 */
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a'); // 创建a标签
                        link.href = url;
                        link.download = fileName; // 文件重命名，若无需重命名，将该行删去
                        link.click();
                        URL.revokeObjectURL(url); // 释放内存
                    }
                    _this.promotion_qr_code_array = [];
                    _this.promotionQRLists();

                    resolve(response);
                })
                .catch((error) => {
                    // _this.$errorMsg(error)
                });
        },
        // 列表删除

        deletePromotionQR(code) {
            _this.promotion_qr_code_array = [];
            _this.promotion_qr_code_array.push(code.promotion_qr_code);

            this.$confirm('您确认要删除吗？删除后，渠道码将作废！数据统计将失效，请慎重操作！ 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    _this
                        .$post('/promotion/deletePromotionQR', {
                            promotion_qr_code_array: _this.promotion_qr_code_array
                        })
                        .then((res) => {
                            _this.$message.success(res.msg);

                            _this.promotion_qr_code_array = [];
                            _this.promotionQRLists();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.promotion_qr_code_array = [];

                    _this.promotionQRLists();
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 批量删除
        batchDelete() {
            if (_this.promotion_qr_code_array.length == 0) {
                _this.$message.warning('请至少勾选一条数据');

                return;
            }

            _this
                .$confirm('您确认要删除吗？删除后，渠道码将作废！数据统计将失效，请慎重操作！ 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/promotion/deletePromotionQR', {
                            promotion_qr_code_array: _this.promotion_qr_code_array
                        })
                        .then((res) => {
                            _this.$message.success(res.msg);

                            _this.promotion_qr_code_array = [];
                            _this.promotionQRLists();

                            return;
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.promotion_qr_code_array = [];

                    _this.promotionQRLists();
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        bind(val) {
            _this.bind_isShow = !_this.bind_isShow;

            _this.bindData = val;
        },

        searchPromotionQRLists() {
            _this.search_data.page = 1;
            _this.promotionQRLists();
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.promotionQRLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style><style>
.promotion_qr_code .el-input__inner {
    width: 330px;
}
</style>
